import { InjectionToken } from "@angular/core"

export const TIMER_START = new InjectionToken<number>("TimerStart");
